module.exports = __webpack_public_path__ + "img/img5.72db59f9.png";